import axios from 'axios';
import API_URLS from "../../config/global_variables";
import axiosInstance from "./authInstance"

export const login = async (email, password) => {
  try {
    const response = await axios.post(API_URLS.LOGIN, {
      email,
      password,
    });

    return response;
  } catch (error) {
    throw error.response?.data?.message || 'Login failed';
  }
};

export const verifyToken = async () => {
  return axiosInstance.get(API_URLS.VRIFY_TOKEN);
};